import React, { Component } from "react";
import { logout } from "../services/authService";

class Logout extends Component {
  componentDidMount() {
    logout();

    window.location = "/login";
  }

  render() {
    return <h3>Logging you out...</h3>;
  }
}

export default Logout;
